import ApiService from "@/core/services/api.service";
// action types
export const GET_CONTENIDO = "getContenido";
export const GET_NOVEDADES = "getNovedades";
export const GET_BENEFICIOS = "getBeneficios";
export const GET_PROMOCIONES = "getPromociones";
export const GET_SOCIALES = "getSociales";
export const GET_CONDOMINIOS = "getCondominios";
export const GET_ACTIVIDADES = "getActividades";
// mutation types
export const SET_ERROR = "setError";
export const SET_CONTENIDO = "setContenido";
export const SET_NOVEDADES = "setNovedades";
export const SET_BENEFICIOS = "setBeneficios";
export const SET_PROMOCIONES = "setPromociones";
export const SET_SOCIALES = "setSociales";
export const SET_CONDOMINIOS = "setCondominios";
export const SET_ACTIVIDADES = "setActividades";

const state = {
  errors: [],
  contenido:{},
  novedades:{contenido:[]},
  beneficios:{contenido:[]},
  promociones:{contenido:[]},
  sociales:{contenido:[]},
  condominios:{contenido:[]},
  actividades:{contenido:[]}
};

const actions = {
  [GET_CONTENIDO](context, id) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/gateway/Contenido/v1/mibricsa/contenido/${id}`}, '')
        .then(({ data }) => {
          context.commit(SET_CONTENIDO, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  } ,
  [GET_NOVEDADES](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/gateway/Contenido/v1/mibricsa/novedades`}, '')
        .then(({ data }) => {
          context.commit(SET_NOVEDADES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  } ,
  [GET_BENEFICIOS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/gateway/Contenido/v1/mibricsa/beneficios`}, '')
        .then(({ data }) => {
          context.commit(SET_BENEFICIOS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  } ,
  [GET_PROMOCIONES](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/gateway/Contenido/v1/mibricsa/promociones`}, '')
        .then(({ data }) => {
          context.commit(SET_PROMOCIONES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  } ,
  [GET_SOCIALES](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/gateway/Contenido/v1/mibricsa/sociales`}, '')
        .then(({ data }) => {
          context.commit(SET_SOCIALES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  } ,
  [GET_CONDOMINIOS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/gateway/Contenido/v1/mibricsa/condominios`}, '')
        .then(({ data }) => {
          context.commit(SET_CONDOMINIOS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  } ,
  [GET_ACTIVIDADES](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/gateway/Contenido/v1/mibricsa/actividades`}, '')
        .then(({ data }) => {
          context.commit(SET_ACTIVIDADES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  } ,
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_CONTENIDO](state, data) {
    state.errors = {};
    state.contenido = data;
  },
  [SET_NOVEDADES](state, data) {
    state.errors = {};
    state.novedades = data;
  },
  [SET_BENEFICIOS](state, data) {
    state.errors = {};
    state.beneficios = data;
  },
  [SET_PROMOCIONES](state, data) {
    state.errors = {};
    state.promociones = data;
  },
  [SET_SOCIALES](state, data) {
    state.errors = {};
    state.sociales = data;
  },
  [SET_CONDOMINIOS](state, data) {
    state.errors = {};
    state.condominios = data;
  },
  [SET_ACTIVIDADES](state, data) {
    state.errors = {};
    state.actividades = data;
  },
};

export default {
  state,
  actions,
  mutations
};
